import { State, Action, StateContext, Store, Selector } from '@ngxs/store';
import { filter, map, take, distinctUntilKeyChanged } from 'rxjs/operators';
import { clone } from 'lodash';

import { Location } from '@app/models/locations/locations.model';

const category = 'Header';

export class ShowSelector {
    static readonly type = `[${category}] ShowSelector`;
    constructor(public show: boolean) {}
}

export class ChangeLocation {
    static readonly type = `[${category}] ChangeLocation`;
    constructor(public loc: Location) {}
}

interface IHeaderState {
    selectorShown: boolean;
    location: Location;
}

@State<IHeaderState>({
    name: 'header',
    defaults: {
        selectorShown: false,
        location: null,
    },
})
export class HeaderState {
    constructor(private store: Store) {}

    @Selector([HeaderState])
    static selectorShown(state: IHeaderState) {
        return state.selectorShown;
    }

    @Selector([HeaderState])
    static currentLocation(state: IHeaderState) {
        return state.location;
    }

    @Action(ShowSelector)
    showSelector(ctx: StateContext<IHeaderState>, action: ShowSelector) {
        ctx.patchState({
            selectorShown: action.show,
        });
    }

    @Action(ChangeLocation)
    changeLocation(ctx: StateContext<IHeaderState>, action: ChangeLocation) {
        localStorage.setItem('location', action.loc.id.toString());
        ctx.patchState({
            location: action.loc,
        });
    }

    getLocation() {
        return this.store.select(HeaderState.currentLocation).pipe(
            filter((loc) => !!loc),
            map((loc) => clone(loc)),
            take(1)
        );
    }

    onChangeLocation() {
        return this.store.select(HeaderState.currentLocation).pipe(
            filter((loc) => !!loc),
            distinctUntilKeyChanged('id'),
            map((loc) => clone(loc))
        );
    }
}
